<template>
    <div class="frame content my">
        <h2>Oops!</h2>
        <p>
            Não foi possível carregar os dados desta página. Tente acessar novamente mais tarde, por
            favor.
        </p>
        <p>
            Caso o erro persista, você pode falar com a gente
            <a class="text-accent text-underline" href="fale-conosco">clicando aqui</a>.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'ErrorWarning',
    };
</script>
